"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinesPaxRange = void 0;
const getOrderVersionPax_1 = require("./getOrderVersionPax");
const getOrderLinesPaxRange = (order_lines) => {
    if (!order_lines)
        return {
            min: 0,
            max: 0,
        };
    if (order_lines.length === 0)
        return {
            min: 0,
            max: 0,
        };
    // get the lowest and highest pax from all order lines
    const paxRange = order_lines.reduce((acc, cur) => {
        const pax = (0, getOrderVersionPax_1.getOrderVersionPax)(cur.latest_version, cur.type);
        console.log("pax", pax);
        return {
            min: Math.min(acc.min, pax),
            max: Math.max(acc.max, pax),
        };
    }, { min: 0, max: 0 });
    return paxRange;
};
exports.getOrderLinesPaxRange = getOrderLinesPaxRange;
